export default __webpack_public_path__ + "static/media/Hek'lar's Accurst Dagger.a6ce8f62.jpg";